<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0">
          <thead class="border-top">
            <tr>
              <th class="text-capitalize">
                {{ "common.accountId" | translate }}
              </th>
              <th class="text-capitalize">
                {{ "common.description" | translate }}
              </th>
              <th class="text-capitalize text-center">
                {{ "common.origin" | translate }}
              </th>
              <th class="text-capitalize">
                {{ "common.todaysSales" | translate }}
              </th>
              <th class="text-capitalize">
                {{ "common.actions" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-bottom" *ngFor="let acc of accounts">
              <td>
                <span>{{ acc.id }}</span>
              </td>
              <td>
                <span>{{ acc.description }}</span>
              </td>
              <td class="text-center" style="width: 48px">
                <img
                  *ngIf="acc?.originCurrency && originMap[acc.originCurrency]"
                  [src]="originMap[acc.originCurrency].flag"
                  [alt]="acc.originCurrency"
                  width="20"
                  height="20"
                />
              </td>

              <td>
                <span>{{
                  acc.todaysSales | formatCurrency : acc.originCurrency
                }}</span>
              </td>

              <td>
                <button
                  type="button"
                  class="btn btn-primary btn-sm btn-pill btn-md our-button px-2"
                  (click)="onSwitchAccount(acc.id)"
                  [disabled]="switchingId === acc.id"
                >
                  <i class="fe fe-log-in me-1"></i>
                  {{
                    switchingId === acc.id
                      ? ("common.loading" | translate)
                      : ("common.access" | translate)
                  }}
                </button>
              </td>
            </tr>

            <tr *ngIf="accounts.length == 0">
              <td colspan="7">{{ "common.noData" | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <ngb-pagination
        [collectionSize]="total"
        [maxSize]="5"
        [rotate]="true"
        [(page)]="page"
        [pageSize]="pageSize"
        (pageChange)="pageChange()"
      >
      </ngb-pagination>
    </div>
  </div>
</form>

<ng-template #modalConfirmEnable let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ selectedUser.active ? "Desativar" : "Ativar" }} usuário?
      </h5>
      <button
        type="button"
        class="btn-close"
        (click)="modal.dismiss(); loadData()"
      ></button>
    </div>
    <div class="modal-body">
      <p>
        Deseja realmente {{ selectedUser.active ? "desativar" : "ativar" }} o
        usuário <b>{{ selectedUser.name }}</b
        >?
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="modal.dismiss(); loadData()">
        Cancelar
      </button>
      <button
        class="btn btn-{{ selectedUser.active ? 'danger' : 'primary' }}"
        [disabled]="updatingId === selectedUser?.id"
        (click)="toggleActive(selectedUser, modal)"
      >
        {{ selectedUser.active ? "Desativar" : "Ativar" }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click'); isLoaded = true"
    ></button>
  </div>

  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>

    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        id="authToken"
        placeholder="Token"
        [(ngModel)]="validationCode"
        (keyup.enter)="validateTotp()"
      />
      <button
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{ "login.totp.pasteButton" | translate }}
      </button>
    </div>
  </div>

  <div class="modal-footer text-center">
    <button
      type="submit"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
      [disabled]="validatingTotp"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
